<div *ngIf="isPasswordResetCompleted" class="container-scroller">
  <div class="container-fluid page-body-wrapper full-page-wrapper">
    <div class="content-wrapper d-flex align-items-center auth px-0">
      <div class="row w-100 mx-0">
        <div class="col-lg-5 mx-auto">
          <div class="auth-form-light text-left py-5 px-4 px-sm-5">
            <h4>Password reset</h4>
            <h6 class="font-weight-light">Reset your password</h6>
            <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()" (keydown.enter)="$event.preventDefault(); resetButton.focus(); resetButton.click()" method="post" class="pt-3">
              <div class="form-group">
                <div class="mr-2 flex-fill me-4 password-max-width">
                  <div class="password-input-container">
                    <input formControlName="password" [type]="showPassword ? 'text' : 'password'" #passwordInput
                           placeholder="Password*"
                           class="form-control form-control-lg password-reduced-placeholder-width"
                           [ngClass]="{'has-error': resetPasswordFormControl['password'].invalid && resetPasswordFormControl['password'].touched}"/>
                    <span class="eye-icon">
      <i class="bi" [ngClass]="{'bi-eye': showPassword, 'bi-eye-slash': !showPassword}"
         (click)="togglePasswordVisibility('password')"></i>
    </span>
                  </div>
                  <div *ngIf="resetPasswordFormControl['password'].invalid && resetPasswordFormControl['password'].touched"
                       class="validation">
                    <small *ngIf="resetPasswordFormControl['password'].errors?.['required']">Enter password</small>
                    <small *ngIf="resetPasswordFormControl['password'].errors?.['pattern']">Enter valid password</small>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="mr-2 flex-fill me-4 password-max-width">
                  <div class="password-input-container">
                    <input formControlName="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'"
                           #confirmPasswordInput
                           placeholder="Confirm password*"
                           class="form-control form-control-lg confirm-password-reduced-placeholder-width"
                           [ngClass]="{'has-error': resetPasswordFormControl['confirmPassword'].invalid && resetPasswordFormControl['confirmPassword'].touched
                           || (resetPasswordFormControl['confirmPassword'].value !== '' && passwordMatchValidator(resetPasswordForm))}"/>
                    <span class="eye-icon">
      <i class="bi" [ngClass]="{'bi-eye': showConfirmPassword, 'bi-eye-slash': !showConfirmPassword}"
         (click)="togglePasswordVisibility('confirmPassword')"></i>
    </span>
                  </div>
                  <div
                    *ngIf="passwordMatchValidator(resetPasswordForm) && resetPasswordFormControl['confirmPassword']?.value !== ''"
                    class="validation">
                    <small>Passwords do not match</small>
                  </div>
                  <div
                    *ngIf="resetPasswordFormControl['confirmPassword'].touched && resetPasswordFormControl['confirmPassword'].hasError('required')"
                    class="validation">
                    <small>Confirm password</small>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <button class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" type="submit" #resetButton>Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
